// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { WMComponent } from '@front/webmobile/Views/Components/WMComponent';
import { TerceraLinkControlConstants } from '../../UtilsClasses/TerceraLinkControlConstants';
export class ApplicationPanel extends WMComponent {
    constructor(props, ViewModel) {
        super(props, ViewModel);
    }
}
ApplicationPanel.defaultProps = {
    symbolLinkValue: TerceraLinkControlConstants.ColorConstants.NONE,
    accountLinkValue: TerceraLinkControlConstants.ColorConstants.NONE,
    canLinkByAccount: true,
    isAccountLinkShow: false,
    isSymbolLinkShow: false,
    onLocalize: () => { },
    onAccountLink: () => { },
    onLinkSystemUpdated: () => { },
    onEvent: null
};
